import script from "./TesLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TesLogin.vue?vue&type=script&setup=true&lang=js"

import "./TesLogin.vue?vue&type=style&index=0&id=ba80fb7c&lang=css"

const __exports__ = script;

export default __exports__